import { render, staticRenderFns } from "./VerifyIdentityRegistration.vue?vue&type=template&id=684ed492"
import script from "./VerifyIdentityRegistration.vue?vue&type=script&lang=js"
export * from "./VerifyIdentityRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports